import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { Loader, ErrorState, EmptyState, PageHeader } from "../../components/common/States";
import { fmtDate } from "../../lib/labels";

export default function AdminContact() {
  const [status, setStatus] = useState("nouveau");
  const { data, loading, error, reload } = useApi(`/admin/contact-messages?status=${status}`);
  const mark = async (m, s) => {
    try { await api.patch(`/admin/contact-messages/${m.id}`, { status: s }); toast.success("Message mis à jour"); reload(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div>
      <PageHeader title="Messages de contact" description="Messages envoyés depuis la page Contact du site public."
        actions={<select className="field-select w-44" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="admin-contact-status-filter">
          <option value="nouveau">Nouveaux</option><option value="traite">Traités</option><option value="">Tous</option>
        </select>} />
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && !data.length && <EmptyState icon={Mail} title="Aucun message" />}
      <div className="space-y-3">
        {data?.map((m) => (
          <div key={m.id} className="card-surface p-5" data-testid={`admin-contact-${m.id}`}>
            <div className="flex flex-wrap items-center gap-2">
              <p className="font-medium">{m.subject}</p>
              <span className="ml-auto text-xs text-slate-400">{fmtDate(m.created_at)}</span>
            </div>
            <p className="text-sm text-slate-500">{m.name} · <a href={`mailto:${m.email}`} className="text-blue-600" data-testid={`admin-contact-mail-${m.id}`}>{m.email}</a></p>
            <p className="mt-2 whitespace-pre-wrap text-sm text-slate-700">{m.message}</p>
            <Button size="sm" variant="outline" className="mt-3" onClick={() => mark(m, m.status === "nouveau" ? "traite" : "nouveau")} data-testid={`admin-contact-toggle-${m.id}`}>
              {m.status === "nouveau" ? "Marquer comme traité" : "Rouvrir"}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
